export const navigationBarBrandStyles = {
  navBarIcon: {
    height: 40,
    width: "auto",
  },
  iconContainer: {
    textAlign: "center",
  },
};
